import React from 'react';
import { Handle, Position } from 'reactflow';

class NodeInitial extends React.Component {
  render() {
    return (
      <>
        <div className="dndnode input">
          Click to Check Condition
        </div>
        <Handle type="target" position={Position.Top} />
        <Handle type="source" position={Position.Left} id="left" />
        <Handle type="source" position={Position.Right} id="right" />
      </>
    );
  }
}

export default NodeInitial;
